import { motion } from "framer-motion";
import logo from "./logo2.png";
import { Link } from "react-scroll";
import { useState } from "react";
import { AiOutlineClose, AiOutlineMenuUnfold } from "react-icons/ai";

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);

  const navItems = [
    { name: "Home", path: "main" },
    { name: "About", path: "about" },
    { name: "Projects", path: "projects" },
    { name: "Contact", path: "contact" },
  ];

  return (
    <nav className="z-50 bg-[#0a192f]/60 sticky top-0 backdrop-blur-md w-full">
      <div className="max-w-7xl mx-auto  sm:px-6 lg:px-8 ">
        <div className="flex items-center justify-between h-16 overflow-hidden">
          <div className="flex-shrink-0">
            <a href="/" className="text-white font-bold text-xl">
              <img alt="/" className="h-[75px] mt-1 " src={logo} />
            </a>
          </div>
          <div className="flex">
            <div className="hidden md:block ">
              <div className="ml-10 flex items-baseline space-x-4">
                {navItems.map((item, index) => (
                  <motion.span
                    key={item.name}
                    initial={{ y: -1000, opacity: 0 }}
                    animate={{
                      x: 0,
                      y: 0,
                      opacity: 1,
                      transition: { duration: 0.5 * index },
                    }}
                  >
                    <Link
                      activeClass="active"
                      to={item.path}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      className="cursor-pointer"
                    >
                      <span className="text-[#64ffda]">0{index + 1}.</span>
                      <span className="text-gray-300  hover:text-[#64ffda] px-3 py-2 rounded-md text-[16px] font-semibold hover:underline">
                        {item.name}
                      </span>
                    </Link>
                  </motion.span>
                ))}
              </div>
            </div>
          </div>
          {sidebar ? (
            <div
              className="text-gray-300 md:hidden text-xl mr-4 z-50"
              onClick={() => setSidebar(false)}
            >
              <AiOutlineClose />
            </div>
          ) : (
            <div
              className="text-gray-300 md:hidden text-xl mr-4"
              onClick={() => setSidebar(true)}
            >
              <AiOutlineMenuUnfold />
            </div>
          )}

          <div
            className={
              sidebar
                ? "md:hidden fixed  right-0 top-12 flex flex-col items-center justify-between w-[40%] h-[55%]   ease-in duration-500 z-10 p-4"
                : "fixed left-[-100%] top-20 flex flex-col h-[55%] items-center justify-between ease-in duration-500 z-10"
            }
          >
            <div className="bg-[#0a192f]/50 rounded-bl-2xl flex flex-col justify-center items-center p-3">
              {navItems.map((item, index) => (
                <motion.span
                  key={item.name}
                  initial={{ y: 0, opacity: 0 }}
                  whileInView={{
                    x: 0,
                    y: 0,
                    opacity: 1,
                    transition: { duration: 0.7 * (index + 1) },
                  }}
                >
                  <Link
                    key={item.name}
                    activeClass="active"
                    to={item.path}
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    className="cursor-pointer"
                    onClick={() => setSidebar(false)}
                  >
                    <span className="text-[#64ffda]">0{index + 1}.</span>
                    <span className="text-gray-300  hover:text-[#64ffda] px-3 py-2 rounded-md text-[16px] font-semibold hover:underline">
                      {item.name}
                    </span>
                  </Link>
                </motion.span>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="text-[#64ffda] bg-[#64ffda] h-[1px]"></div> */}
    </nav>
  );
};

export default Navbar;
